<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.6547 1C19.3223 1 22.0746 4.85087 22.2026 5.00869L22.32 5.17704V13.6784C22.32 20.4332 13.3161 23.7264 12.932 23.8843L12.676 24H12.6547L12.388 23.8843C12.0146 23.7264 3 20.4332 3 13.6784V5.2086L3.11735 5.04026C3.22403 4.85087 5.98708 1 12.6547 1ZM12.6547 2.30467C7.37394 2.30467 4.87759 4.92452 4.32285 5.5979V13.6784C4.32285 18.9918 11.2145 21.9062 12.6547 22.5691C14.0842 21.9062 20.9865 18.9812 20.9865 13.6784V5.5979C20.4317 4.93504 17.9354 2.30467 12.6547 2.30467ZM12.6547 4.95608L18.7888 9.21729V17.2347H6.50982V9.21729L12.6547 4.95608ZM12.6547 6.65005L7.854 10.038L7.85392 16.1506H17.444L17.4447 10.038L12.6547 6.65005ZM12.6493 12.7126C14.1317 12.7126 15.3584 13.85 15.4497 15.3092H9.84894C9.94031 13.85 11.1669 12.7126 12.6493 12.7126ZM12.6013 9.4172C13.3572 9.4172 13.9717 10.0185 13.9775 10.764L14.0202 10.7219C14.0415 11.2712 13.7247 11.779 13.2179 12.0079C12.711 12.2367 12.1143 12.1414 11.7065 11.7665C11.2988 11.3916 11.1607 10.8112 11.3567 10.2965C11.5527 9.78186 12.0442 9.43465 12.6013 9.4172Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNPMAMyNPMA',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>